module.exports = __webpack_public_path__ + "media/toolkits/block-5-image-13800caf.png";